/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import * as Config from "./config";

async function reqMainMenu() {    
	const API_URI_MENU_PRINCIPAL = Config.mainMenuRoute;
    const response = await axios.get(API_URI_MENU_PRINCIPAL);    
    return response.data;    
}

export default {
    reqMainMenu
};
